import { useState } from 'react';
import { FoldPanel, Specimens, Tag } from '@src/components';

const INTERESTS = ['Books', 'Board games', 'Cooking', 'Plants'];

export function TagSection() {
  const [picked, setPicked] = useState<string[]>(['Books', 'Cooking']);
  const [filters, setFilters] = useState<string[]>(['Wishlist']);

  function toggle(list: string[], value: string): string[] {
    return list.includes(value) ? list.filter((item) => item !== value) : [...list, value];
  }

  return (
    <FoldPanel
      id="tags"
      title="Tags"
      hint="A chip: a filter, a facet, a removable token. The selection colour when on — coral stays on actions."
      example={`<Tag
  selected={picked}
  onSelectedChange={setPicked}
  onDismiss={() => remove('Books')}
>
  Books
</Tag>`}
    >
      <Specimens
        label="Medium"
        note="Default size. Click to toggle; the filled ones are in play."
      >
        {INTERESTS.map((interest) => (
          <Tag
            key={interest}
            selected={picked.includes(interest)}
            onSelectedChange={() => setPicked((current) => toggle(current, interest))}
          >
            {interest}
          </Tag>
        ))}
      </Specimens>

      <Specimens label="Small" note="Same matrix, tighter — for dense filter rows.">
        {INTERESTS.map((interest) => (
          <Tag
            key={interest}
            size="small"
            selected={picked.includes(interest)}
            onSelectedChange={() => setPicked((current) => toggle(current, interest))}
          >
            {interest}
          </Tag>
        ))}
      </Specimens>

      <Specimens
        label="Dismissible"
        note="The close mark is its own button, so removing a tag never also toggles it."
      >
        {filters.map((filter) => (
          <Tag
            key={filter}
            selected
            onDismiss={() => setFilters((current) => current.filter((item) => item !== filter))}
            dismissLabel={`Remove ${filter}`}
          >
            {filter}
          </Tag>
        ))}
        <Tag onDismiss={() => undefined} dismissLabel="Remove example">
          Quiet
        </Tag>
        <Tag size="small" selected onDismiss={() => undefined} dismissLabel="Remove small">
          Small
        </Tag>
      </Specimens>

      <Specimens label="Static" note="No handlers — a label, not a control.">
        <Tag>Secret Santa</Tag>
        <Tag selected>Selected</Tag>
        <Tag size="small">Small</Tag>
        <Tag disabled>Disabled</Tag>
      </Specimens>
    </FoldPanel>
  );
}
